import {
  CardContent,
  Chip,
  Grid,
  Typography,
  TableHead,
  Tooltip,
  Table,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Pagination,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  AdminTitleHolder,
  CustomDocumentLink,
} from "../../../common/sharedComponents/styles/card.style";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { styled as materialStyles } from "@mui/material/styles";
import Card from "@mui/material/Card";
import styled from "styled-components";
import {
  approveOrderByVendor,
  getAdminOrderDetails,
  getInvoiceListByOrderId,
  getLedgerList,
  getViewLedgerDetails,
  rejectOrderByVendor,
} from "../redux/adminOrdersSlice";
import InfoIcon from "@mui/icons-material/Info";
import {
  CustomTableContainer,
  // TableHeaderFont,
} from "../../../styles/tableContent.style";
import moment from "moment";
import { RemoveRedEye } from "@mui/icons-material";
// import { VendorCardSubTitle } from "../../vendorRegistration/components/steps/cardTrial";
import {
  ApproveButton,
  RejectButton,
} from "../../vendorRegistration/components/ViewvendorDetails";
import { message } from "antd";
import LocalStorage from "../../../utilities/localStorage";
import { getInvoiceDetails } from "../../adminInvoices/redux/adminInvoicesSlice";

function AdminOrdersViewContent() {
  const role = LocalStorage.getItem("tata_login_user").roles;
  const clientId = LocalStorage.getItem("client")?.id;
  const params = useParams();
  const dispatch = useDispatch();
  const order_id = params.orderid;
  const {
    adminOrderDetails,
    loading,
    approveOrderLoading,
    invoiceListLoading,
    invoiceList,
    ledgerListLoading,
    ledgerList,
    ledgerDetailsLoaing,
  } = useSelector((state) => state.adminOrders);
  const { invoice_details_loading } = useSelector(
    (state) => state.adminInvoices
  );
  const [open, setOpen] = React.useState(false);
  const [openRej, setOpenRej] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(10);
  const [viewModal, setViewModal] = useState(false);
  const [viewItemDetails, setViewItemDetails] = useState(null);
  const [ledgerViewOpen, setLedgerViewOpen] = React.useState(false);
  const [ledgerPage, seLedgerPage] = React.useState(1);
  const [ledgerPerPage, setLedgerPerPage] = React.useState(10);
  const [ledgerViewItemDetails, setLedgerViewItemDetails] = useState(null);
  const [reason, setReason] = useState(null);

  const orderDetails = [
    { label: "ORDER TYPE", key: "order_type" },
    { label: "PO NUMBER", key: "order_number" },

    {
      label: "PO DATE",
      key: "order_date",
      format: (value) => moment(value).format("DD/MM/YYYY"),
    },
    { label: "PAYMENT TERMS", key: "payment_terms" },
    { label: "DELIVERY TERMS", key: "delivery_terms" },
  ];
  const vendorDetails = [
    { label: "VENDOR COMPANY NAME", key: "company_name" },
    { label: "VENDOR EMAIL", key: "company_email" },
    { label: "VENDOR CODE", key: "vendor_code" },
  ];
  const tableHeaders = [
    { label: "Sr. No.", key: "sr_no" },
    { label: "Item Code", key: "MaterialCode" },
    { label: "Item Name", key: "Description" },
    { label: "Item Description", key: "item_description" },
    { label: "Quantity", key: "quantity" },
    { label: "UOM", key: "uom" },
    { label: "Rate", key: "unit_price" },
    { label: "Discount in %", key: "discount" },
    { label: "Location", key: "location" },
    { label: "GST Type", key: "gst_type" },
    { label: "GST in %", key: "gst_per" },
    { label: "Item Total Amount", key: "unit_total_price" },
    {
      label: "Date of Delivery",
      key: "delievery_date",
    },
  ];
  const bankDetails = [
    { label: "A/C NAME", key: "account_name" },
    { label: "BANK ACCOUNT NUMBER", key: "account_number" },
    { label: "BANK NAME", key: "bank_name" },
    { label: "IFSC CODE", key: "ifsc_code" },
    { label: "SWIFT CODE", key: "swift_code" },
  ];

  const buyerDetails = [
    { label: "BUYER COMPANY NAME", key: "company_name" },
    { label: "BUYER ADDRESS", key: "company_location" },
    // { label: "PIN CODE", key: "buyer_pin_code" },
    // { label: "STATE", key: "buyer_state" },
    // { label: "CITY", key: "buyer_city" },
    { label: "GSTIN/UIN", key: "gstin_uin" },
  ];
  // const agentDetails = [
  //   { label: "AGENT COMPANY NAME", key: "agent_company_name" },
  //   { label: "AGENT ADDRESS", key: "agent_address" },
  //   { label: "PIN CODE", key: "agent_pin_code" },
  //   { label: "STATE", key: "agent_state" },
  //   { label: "CITY", key: "agent_city" },
  //   { label: "GSTIN", key: "agent_gstin" },
  // ];
  const invoiceColumns = [
    { label: "Sr. No.", key: "srNo" },
    { label: "PO Number", key: "order_number" },
    { label: "Invoice Number", key: "invoice_number" },
    { label: "Invoice Date", key: "invoice_date" },
    { label: "Invoice Amount", key: "invoice_amount" },
    { label: "Action", key: "action" },
  ];
  const ledgerColumns = [
    { label: "Sr. No.", key: "srNo" },
    { label: "Invoice Number", key: "invoice_number" },
    { label: "Invoice Amout", key: "amount" },
    { label: "Payment Date", key: "payment_date" },
    { label: "Payment Type", key: "payment_type" },
    { label: "Action", key: "action" },
  ];
  const addressDetails = [
    { label: "LOCATION", key: "delivery_location" },
    // { label: "CITY", key: "city" },
    // { label: "STATE", key: "state" },
    // { label: "COUNTRY", key: "country" },
    // { label: "PIN CODE", key: "pin_code" },
    // { label: "GSTIN", key: "gstin" },
  ];
  const viewItemFields = [
    { label: "PO NUMBER", key: "order_number" },
    { label: "INVOICE NUMBER", key: "invoice_number" },
    {
      label: "INVOICE DATE",
      key: "invoice_date",
      formatter: (value) => moment(value).format("DD MMM YYYY"),
    },

    { label: "INVOICE AMOUNT", key: "invoice_amount" },
  ];
  const viewLedgerItemFields = [
    { label: "INVOICE NUMBER", key: "invoice_number" },
    { label: "INVOICE AMOUNT", key: "amount" },
    {
      label: "PAYMENT DATE",
      key: "payment_date",
      formatter: (value) => moment(value).format("DD MMM YYYY"),
    },
    { label: "INVOICE TYPE", key: "payment_type" },
    { label: "REMARKS", key: "remark" },
    { label: "PENALTY", key: "penalty" },
    { label: "TAT", key: "tax" },
    { label: "TDS", key: "tds" },
    { label: "DISCREPANCY", key: "discrepancy" },
  ];
  const handleViewModalOpen = (itemID) => {
    setViewModal(true);
    dispatch(getInvoiceDetails(itemID)).then((res) => {
      if (res.payload.success) {
        setViewItemDetails({
          ...res?.payload?.data,
          order_number: res?.payload?.data?.Order?.order_number,
        });
      } else {
        message.error(res.payload.message);
      }
    });
  };
  const handleViewModalClose = () => {
    setViewModal(false);
    setViewItemDetails(null);
  };
  const handleLedgerViewModalOpen = (itemID) => {
    setLedgerViewOpen(true);
    dispatch(getViewLedgerDetails(itemID)).then((res) => {
      if (res.payload.success) {
        setLedgerViewItemDetails({
          ...res?.payload?.data,
          invoice_number: res?.payload?.data?.invoice_details?.invoice_number,
        });
      } else {
        message.error(res.payload.message);
      }
    });
  };
  const handleLedgerViewModalClose = () => {
    setLedgerViewOpen(false);
    setLedgerViewItemDetails(null);
  };
  const viewOrderDetails = (order_id) => {
    dispatch(getAdminOrderDetails(order_id));
  };
  const getInvoiceList = (order_id) => {
    dispatch(
      getInvoiceListByOrderId({
        order_id: order_id,
        page: page,
        per_page: perPage,
      })
    );
  };
  const getLedgerListFc = (order_id) => {
    dispatch(
      getLedgerList({
        order_id: order_id,
        page: ledgerPage,
        per_page: ledgerPerPage,
      })
    );
  };
  useEffect(() => {
    viewOrderDetails(order_id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getLedgerListFc(order_id);
    // eslint-disable-next-line
  }, [ledgerPage, ledgerPerPage]);

  useEffect(() => {
    getInvoiceList(order_id);
    // eslint-disable-next-line
  }, [page, perPage]);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setReason(null);
  };
  const handleClickOpenReject = () => {
    setOpenRej(true);
  };
  const handleCloseRej = () => {
    setOpenRej(false);
    setReason(null);
  };
  const handleApproveOrder = () => {
    try {
      dispatch(
        approveOrderByVendor({ order_id: order_id, reason: reason })
      ).then((response) => {
        if (response.payload.success) {
          setOpen(false);
          viewOrderDetails(order_id);
        } else {
          setOpen(false);
        }
      });
    } catch (error) {
      message.error(error);
    }
  };
  const handleRejectOrder = () => {
    try {
      dispatch(
        rejectOrderByVendor({ order_id: order_id, reason: reason })
      ).then((response) => {
        if (response.payload.success) {
          setOpenRej(false);
          viewOrderDetails(order_id);
        } else {
          setOpenRej(false);
        }
      });
    } catch (error) {
      message.error(error);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this order?
          </DialogContentText>
          {/* <div style={{ width: "100%" }}>
            <TextField
              multiline
              rows={4}
              placeholder="Enter Reject Reason"
              style={{
                width: "100%",
                paddingTop: "3px",
                fontSize: "8px",
                fontFamily: "var(--font-family-reg)",
              }}
              fullWidth
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div> */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              borderColor: "rgb(28 182 151)",
              color: "#0f0f0f",
            }}
            size="small"
            // color="success"
          >
            Cancel
          </Button>
          <ApproveButton
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "var(--button-color)",
              color: "white",
            }}
            onClick={(e) => handleApproveOrder()}
            autoFocus
            size="small"
            disabled={approveOrderLoading}
          >
            {approveOrderLoading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Approve"
            )}
          </ApproveButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRej}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to reject this order?
          </DialogContentText>
          <div style={{ width: "100%" }}>
            <TextField
              multiline
              rows={4}
              placeholder="Enter Reject Reason"
              style={{
                width: "100%",
                paddingTop: "3px",
                fontSize: "8px",
                fontFamily: "var(--font-family-reg)",
              }}
              required
              fullWidth
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseRej}
            variant="outlined"
            style={{
              borderColor: "rgb(211 47 47)",
              color: "#0f0f0f",
            }}
            size="small"
          >
            Cancel
          </Button>
          <RejectButton
            color="error"
            variant="contained"
            style={{
              float: "right",
            }}
            onClick={(e) => handleRejectOrder()}
            autoFocus
            size="small"
            disabled={approveOrderLoading || !reason?.trim().length}
          >
            {approveOrderLoading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Reject"
            )}
          </RejectButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={viewModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        onClose={handleViewModalClose}
      >
        <DialogTitle id="alert-dialog-title">
          {`Item #${viewItemDetails?.invoice_number}`}
        </DialogTitle>
        <DialogContent>
          {invoice_details_loading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={4}>
                {viewItemDetails &&
                  viewItemFields.map((field) => (
                    <Grid item xs={3} md={3}>
                      <Typography className="label">{field.label}</Typography>
                      <VendorCardLabel>
                        {field.formatter
                          ? field.formatter(viewItemDetails?.[field.key])
                          : viewItemDetails?.[field.key]}
                      </VendorCardLabel>
                    </Grid>
                  ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Invoice Documents</VendorCardTitle>

              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">Invoice Documents</Typography>
                  {viewItemDetails?.Invoice_documents !== undefined &&
                  viewItemDetails?.Invoice_documents !== null &&
                  viewItemDetails?.Invoice_documents.length > 0 ? (
                    viewItemDetails?.Invoice_documents.map((item, index) => (
                      <VendorCardLabel key={index}>
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={item?.document_url}
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            {item?.document_title}
                          </CustomDocumentLink>
                        </Tooltip>
                      </VendorCardLabel>
                    ))
                  ) : (
                    <Typography className="label">
                      <InfoIcon
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There are no Invoice documents
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleViewModalClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ledgerViewOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        onClose={handleLedgerViewModalClose}
      >
        <DialogTitle id="alert-dialog-title">
          {`Item #${ledgerViewItemDetails?.invoice_number}`}
        </DialogTitle>
        <DialogContent>
          {ledgerDetailsLoaing ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={4}>
                {ledgerViewItemDetails &&
                  viewLedgerItemFields.map((field) => (
                    <Grid
                      item
                      xs={field.key === "remark" ? 12 : 3}
                      md={field.key === "remark" ? 12 : 3}
                    >
                      <Typography className="label">{field.label}</Typography>
                      <VendorCardLabel>
                        {field.formatter
                          ? field.formatter(ledgerViewItemDetails?.[field.key])
                          : ledgerViewItemDetails?.[field.key]
                          ? ledgerViewItemDetails?.[field.key]
                          : "Not Applicable"}
                      </VendorCardLabel>
                    </Grid>
                  ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Documents</VendorCardTitle>
              <Grid container spacing={2}>
                <Grid item xs={6} md={4}>
                  <Typography className="label">LEDGER DOCUMENT</Typography>
                  <VendorCardLabel>
                    {ledgerViewItemDetails?.utr_document ? (
                      ledgerViewItemDetails?.utr_document ? (
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={ledgerViewItemDetails?.utr_document}
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            Ledger Document
                          </CustomDocumentLink>
                        </Tooltip>
                      ) : (
                        <Typography className="label">
                          <InfoIcon
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no ledger document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label">
                        <InfoIcon
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no ledger document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </Grid>
              </Grid>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleLedgerViewModalClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <AdminTitleHolder>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                Order#
                {adminOrderDetails.order_number
                  ? adminOrderDetails.order_number
                  : "Not Applicable"}
              </Grid>
              {adminOrderDetails?.status === "Accepted" ? (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "var(--button-color)",
                      color: "white",
                      float: "right",
                    }}
                    label="Accepted"
                  />
                </Grid>
              ) : adminOrderDetails?.status === "Rejected" ? (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "#d32f2f",
                      color: "white",
                      float: "right",
                    }}
                    label="Rejected"
                  />
                </Grid>
              ) : role[0] === "user" && clientId === 3 ? (
                <Grid item xs={6}>
                  {" "}
                  <ApproveButton
                    onClick={handleClickOpen}
                    variant="outlined"
                    color="success"
                    style={{
                      height: "40px",
                      width: "150px",
                      float: "right",
                    }}
                  >
                    Approve
                  </ApproveButton>
                  <RejectButton
                    onClick={handleClickOpenReject}
                    variant="outlined"
                    color="error"
                    style={{
                      height: "40px",
                      width: "150px",
                      float: "right",
                      marginInline: "1rem",
                    }}
                  >
                    Reject
                  </RejectButton>
                </Grid>
              ) : (
                <Grid item xs={6}>
                  <Chip
                    style={{
                      /*  height: "40px", */
                      width: "100px",
                      borderRadius: "25px",
                      backgroundColor: "#ed6c02",
                      color: "white",
                      float: "right",
                    }}
                    label="Pending"
                  />
                </Grid>
              )}
            </Grid>
          </AdminTitleHolder>
          <StyledCard>
            <CardContent>
              <Grid container spacing={2}>
                {orderDetails.map((detail) => (
                  <Grid item xs={6} md={6} key={detail.key}>
                    <Typography className="label">{detail.label}</Typography>
                    <VendorCardLabel>
                      {detail.format && adminOrderDetails[detail.key]
                        ? detail.format(adminOrderDetails[detail.key])
                        : adminOrderDetails[detail.key] ||
                          "Not Applicable"}{" "}
                    </VendorCardLabel>
                  </Grid>
                ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Vendor Details</VendorCardTitle>
              <Grid container spacing={2}>
                {vendorDetails.map((detail) => (
                  <Grid item xs={6} md={6} key={detail.key}>
                    <Typography className="label">{detail.label}</Typography>
                    <VendorCardLabel>
                      {detail.key === "vendor_code"
                        ? adminOrderDetails?.Vendor?.User?.UsersRoles[0]?.[
                            detail.key
                          ]
                        : adminOrderDetails?.Vendor?.[detail.key] ||
                          "Not Applicable"}
                    </VendorCardLabel>
                  </Grid>
                ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Item Details</VendorCardTitle>
              <CustomTableContainer component={Card}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow
                      style={{
                        backgroundColor: "#e1ebfa",
                      }}
                    >
                      {tableHeaders.map((column, index) => (
                        <TableCell
                          key={index}
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          {column?.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adminOrderDetails?.OrderMaterials?.length ? (
                      adminOrderDetails?.OrderMaterials?.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {tableHeaders.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                  color:
                                    column?.key === "item_name"
                                      ? "#0000FF"
                                      : "inherit",
                                }}
                              >
                                {column?.key === "sr_no" ? (
                                  index + 1
                                ) : column?.key === "item_name" ? (
                                  <Tooltip
                                    arrow
                                    title={
                                      item?.item_description ||
                                      "No description available"
                                    }
                                  >
                                    <span>{item[column?.key]}</span>
                                  </Tooltip>
                                ) : column?.key === "action" ? (
                                  <Tooltip title="View Item">
                                    <IconButton aria-label="view">
                                      <RemoveRedEye
                                        style={{
                                          fill: "royalblue",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        onClick={
                                          () => {}
                                          // handleViewModalOpen(item["itemCode"])
                                        }
                                      />
                                    </IconButton>
                                  </Tooltip>
                                ) : column?.key === "MaterialCode" ||
                                  column?.key === "Description" ? (
                                  item?.MaterialMaster?.[column?.key]
                                ) : column?.key === "delievery_date" ? (
                                  moment(
                                    item?.MaterialMaster?.[column?.key]
                                  ).format("DD/MM/YYYY")
                                ) : item[column?.key] ? (
                                  item[column?.key]
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow
                        // key={index}
                        style={{
                          backgroundColor: "#fafcff",
                        }}
                      >
                        <TableCell
                          colSpan={tableHeaders.length}
                          style={{
                            textAlign: "center",
                            backgroundColor: "#fafcff",
                          }}
                        >
                          <Typography className="label">
                            No item added yet. Start by adding an item.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                {/* <Grid
                container
                className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
              >
                <Grid className="d-flex align-items-center gap-2">
                  <span>Rows per page: </span>
                  <select
                    value={perPage}
                    onChange={(e) => setPerPage(e.target.value)}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </Grid>
                <Pagination
                  sx={{
                    width: "max-content",
                  }}
                  color="primary"
                  variant="text"
                  onChange={(_, newValue) => setPage(newValue)}
                  count={1}
                  page={page}
                  shape="rounded"
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  showFirstButton
                  showLastButton
                />
              </Grid> */}
              </CustomTableContainer>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">ROUND OFF</Typography>
                  <VendorCardLabel>
                    {adminOrderDetails?.round_off
                      ? adminOrderDetails?.round_off
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">TOTAL VALUE</Typography>
                  <VendorCardLabel>
                    {adminOrderDetails?.total_value
                      ? adminOrderDetails?.total_value
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
              <br />
              <VendorCardTitle>
                Beneficiary Details (bank details){" "}
              </VendorCardTitle>
              <Grid container spacing={2}>
                {bankDetails.map((detail) => (
                  <Grid item xs={6} md={6} key={detail.key}>
                    <Typography className="label">{detail.label}</Typography>
                    <VendorCardLabel>
                      {adminOrderDetails?.Bank_information?.[detail.key] ||
                        "Not Applicable"}
                    </VendorCardLabel>
                  </Grid>
                ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Buyer Details</VendorCardTitle>
              <Grid container spacing={2}>
                {buyerDetails.map((detail) => (
                  <Grid item xs={6} md={6} key={detail.key}>
                    <Typography className="label">{detail.label}</Typography>
                    <VendorCardLabel>
                      {adminOrderDetails?.Company?.[detail.key] ||
                        "Not Applicable"}
                    </VendorCardLabel>
                  </Grid>
                ))}
              </Grid>
              <br />
              <br />
              {/* <VendorCardTitle>Agent Details </VendorCardTitle>

          <Grid container spacing={2}>
            {agentDetails.map((detail) => (
              <Grid item xs={6} md={6} key={detail.key}>
                <Typography className="label">{detail.label}</Typography>
                <VendorCardLabel>
                  {adminOrderDetails[detail.key] || "Not Applicable"}
                </VendorCardLabel>
              </Grid>
            ))}
          </Grid>
          <br /> 
          <br /> */}
              <VendorCardTitle>Delivery Address </VendorCardTitle>

              <Grid container spacing={2}>
                {addressDetails.map((detail) => (
                  <Grid
                    item
                    xs={detail.key === "address_line1" ? 12 : 6}
                    md={detail.key === "address_line1" ? 12 : 6}
                    key={detail.key}
                  >
                    <Typography className="label">{detail.label}</Typography>
                    <VendorCardLabel>
                      {adminOrderDetails[detail.key] || "Not Applicable"}
                    </VendorCardLabel>
                  </Grid>
                ))}
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Documents</VendorCardTitle>
              <Grid container spacing={2}>
                <Grid item xs={6} md={4}>
                  <Typography className="label">ORDER DOCUMENT</Typography>
                  <VendorCardLabel>
                    {adminOrderDetails.Order_document?.order_document ? (
                      adminOrderDetails.Order_document?.order_document ? (
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={
                              adminOrderDetails.Order_document?.order_document
                            }
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            Order document
                          </CustomDocumentLink>
                        </Tooltip>
                      ) : (
                        <Typography className="label">
                          <InfoIcon
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no order document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label">
                        <InfoIcon
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no order document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Typography className="label">
                    SUPPORTING DOCUMENTS
                  </Typography>
                  {adminOrderDetails?.Order_document?.supporting_documents !==
                    undefined &&
                  adminOrderDetails?.Order_document?.supporting_documents !==
                    null &&
                  adminOrderDetails?.Order_document?.supporting_documents
                    .length > 0 ? (
                    adminOrderDetails?.Order_document?.supporting_documents.map(
                      (item, index) => (
                        <VendorCardLabel key={index}>
                          <Tooltip title="Download Document">
                            <CustomDocumentLink
                              key={index}
                              href={item}
                              target="_blank"
                            >
                              <InsertDriveFileOutlinedIcon
                                style={{
                                  marginTop: "-1px",
                                  marginRight: "3px",
                                  height: "12px",
                                  width: "12px",
                                }}
                              />
                              Order document
                            </CustomDocumentLink>
                          </Tooltip>
                        </VendorCardLabel>
                      )
                    )
                  ) : (
                    <Typography className="label">
                      <InfoIcon
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There are no order documents
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>

          <StyledCard>
            <CardContent>
              <VendorCardTitle style={{ paddingBottom: "20px" }}>
                Invoice Details
              </VendorCardTitle>
              {invoiceListLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : invoiceList?.data?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {invoiceColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoiceList?.data?.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {invoiceColumns.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                  color:
                                    column?.key === "Description"
                                      ? "#0000FF"
                                      : "inherit",
                                }}
                              >
                                {column?.key === "srNo" ? (
                                  index + 1
                                ) : column?.key === "action" ? (
                                  <Tooltip title="View Item">
                                    <IconButton aria-label="view">
                                      <RemoveRedEye
                                        style={{
                                          fill: "royalblue",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        onClick={() =>
                                          handleViewModalOpen(item?.id)
                                        }
                                      />
                                    </IconButton>
                                  </Tooltip>
                                ) : column?.key === "order_number" ? (
                                  item?.Order?.[column?.key]
                                ) : column?.key === "invoice_date" ? (
                                  moment(item?.Order?.[column?.key]).format(
                                    "DD/MM/YYYY"
                                  )
                                ) : item?.[column?.key] ? (
                                  item?.[column?.key]
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                    sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                  >
                    <Grid className="d-flex align-items-center gap-2">
                      <span>Rows per page: </span>
                      <select
                        value={perPage}
                        onChange={(e) => setPerPage(e.target.value)}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </Grid>
                    <Pagination
                      sx={{
                        width: "max-content",
                      }}
                      color="primary"
                      variant="text"
                      onChange={(_, newValue) => setPage(newValue)}
                      count={invoiceList?.pagination?.total_page}
                      page={page}
                      shape="rounded"
                      showFirstButton
                      showLastButton
                    />
                  </Grid>
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No item added yet. Start by adding an item.
                </Typography>
              )}
            </CardContent>
          </StyledCard>
          <StyledCard>
            <CardContent>
              <VendorCardTitle style={{ paddingBottom: "20px" }}>
                Ledger Details
              </VendorCardTitle>
              {ledgerListLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : ledgerList?.data?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {ledgerColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ledgerList?.data?.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {ledgerColumns.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                  color: "inherit",
                                }}
                              >
                                {column?.key === "srNo" ? (
                                  index + 1
                                ) : column?.key === "action" ? (
                                  <Tooltip title="View Item">
                                    <IconButton aria-label="view">
                                      <RemoveRedEye
                                        style={{
                                          fill: "royalblue",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        onClick={() =>
                                          handleLedgerViewModalOpen(item?.id)
                                        }
                                      />
                                    </IconButton>
                                  </Tooltip>
                                ) : column?.key === "invoice_number" ? (
                                  item?.invoice_details?.[column?.key]
                                ) : column?.key === "payment_date" ? (
                                  moment(item?.Order?.[column?.key]).format(
                                    "DD/MM/YYYY"
                                  )
                                ) : item?.[column?.key] ? (
                                  item?.[column?.key]
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                    sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                  >
                    <Grid className="d-flex align-items-center gap-2">
                      <span>Rows per page: </span>
                      <select
                        value={ledgerPerPage}
                        onChange={(e) => setLedgerPerPage(e.target.value)}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </Grid>
                    <Pagination
                      sx={{
                        width: "max-content",
                      }}
                      color="primary"
                      variant="text"
                      onChange={(_, newValue) => seLedgerPage(newValue)}
                      count={ledgerList?.pagination?.total_page}
                      page={ledgerPage}
                      shape="rounded"
                      showFirstButton
                      showLastButton
                    />
                  </Grid>
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No item added yet. Start by adding an item.
                </Typography>
              )}
            </CardContent>
          </StyledCard>
        </>
      )}
    </>
  );
}
export default AdminOrdersViewContent;

export const StyledCard = materialStyles(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorCardTitle = styled.div`
  text-align: left;
  padding: 0px 20px 15px 0px;
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 18px;
  color: #212134;
`;
